import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import ConjugationTable from "src/components/tables/ConjugationTable";

import {
    subjunctiveTopicDescription,
    subjunctiveUsageInfo,
    subjunctiveIdentification,
    SubjunctiveExamplesData,
    PreteriteSubjunctiveExplanation,
    PastPerfectSubjunctiveExplanation,
    PastPerfectSubjunctiveExamples,
    regularVerbsTableData,
    regularVerbsTableDataPast,
    irregularVerbsTableDataPast,
    irregularVerbsSubjunctivo,
    semiIrregularVerbsSubjunctivo,
    totalIrregularVerbsSubjunctivo,
    pastPerfectSubjunctiveRegular,
    pastPerfectSubjunctiveIrregular,
    subjunctiveStory,
    pastSubjunctiveStoryTrip
} from "src/data/individual-topics/Subjunctive";
import ExampleTitle from "src/components/ExampleTitle";
import PageStructure from "src/components/wrappers/PageStructure";
import { Card } from "antd";
import StoryCard from "src/components/cards/StoryCard";


const SubjunctivoContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>

            <div className="section">
                <ExplanationCard cardData={subjunctiveTopicDescription} />
            </div>

            <ExampleTitle title="Present Subjunctive" />
            <div className="section">
                <ExplanationCard cardData={subjunctiveUsageInfo} />
            </div>
            <div className="section">
                <ExplanationCard cardData={subjunctiveIdentification} />
            </div>

            <div className="section">
                <ConjugationTable tableData={regularVerbsTableData} />
            </div>
            <div className="section">
                <ConjugationTable tableData={irregularVerbsSubjunctivo} />
            </div>
            <div className="section">
                <ConjugationTable tableData={semiIrregularVerbsSubjunctivo} />
            </div>
            <div className="section">
                <ConjugationTable tableData={totalIrregularVerbsSubjunctivo} />
            </div>

            <ExampleTitle title="Present Subjunctive Examples" />
            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {SubjunctiveExamplesData.presentExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <StoryCard story={subjunctiveStory} title="👯‍♂️ Friends Chatting 👯‍♂️" />

            <ExampleTitle title="Past (Imperfect) Subjunctive" />

            <div className="section">
                <ExplanationCard cardData={PreteriteSubjunctiveExplanation} />
            </div>
            <div className="section">
                <ConjugationTable tableData={regularVerbsTableDataPast} />
            </div>
            <div className="section">
                <ConjugationTable tableData={irregularVerbsTableDataPast} />
            </div>

            <ExampleTitle title="Past Imperfect Subjunctive Examples" />
            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {SubjunctiveExamplesData.preteriteExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <ExampleTitle title="Past Perfect Subjunctive" />
            <div className="section">
                <ExplanationCard cardData={PastPerfectSubjunctiveExplanation} />
            </div>
            <div className="section">
                <ConjugationTable tableData={pastPerfectSubjunctiveRegular} />
            </div>
            <div className="section">
                <ConjugationTable tableData={pastPerfectSubjunctiveIrregular} />
            </div>

            <ExampleTitle title="Past Perfect Subjunctive Examples" />
            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {PastPerfectSubjunctiveExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <StoryCard
                story={pastSubjunctiveStoryTrip}
                title="🌍 Two Friends Talking About a Missed Trip 🌍" />
        </div>
    );
};

const SubjunctivoScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Subjunctive"
            Page={<SubjunctivoContent />}
        />
    );
};

export default SubjunctivoScreen;